// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { SagaObject } from '../../../SagaBase/SagaObject';
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class ListCrisisPertinence_abstract extends SagaObject {
  static $t: string = 'SagaSchema.ListObjects.ListCrisisPertinence';
  $t: string = 'SagaSchema.ListObjects.ListCrisisPertinence';

  public static GetMembers(): string[] {
    return ['Name', 'Value', 'isActive', 'Color', 'Abbreviation'].concat(SagaObject.GetMembers());
  }

  public GetMembers(): string[] {
    return ListCrisisPertinence_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Name: string;
  public Value: any;
  public isActive: boolean = false;
  public Color: string = '#00FFFFFF';
  public Abbreviation: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
